import * as React from 'react';
import Box from '@mui/material/Box';
import { JTabStyled, TabsContainer, TabsStyled } from './j-tab.styled';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import { JButton } from '@atoms/JButton';
import { PlusIcon } from '@heroicons/react/24/outline';
import { IconSize } from '@constants';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export interface JTabItem {
  title: string;
  icon?: React.JSX.Element;
  component: React.ReactNode;
}

interface JTabProps {
  items: JTabItem[];
  onClickAdd?: () => void;
}

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
};

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
};

const Jtab = ({ items, onClickAdd }: JTabProps) => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <TabsContainer>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <TabsStyled value={value} onChange={handleChange}>
            {items.map((item, index) => (
              <JTabStyled
                data-qa={item.title}
                iconPosition="start"
                icon={item.icon}
                label={t(item.title)}
                key={item.title}
                {...a11yProps(index)}
              />
            ))}
          </TabsStyled>
          {onClickAdd && (
            <Box padding={1}>
              <JButton
                variant="contained"
                color="secondary"
                onClick={onClickAdd}
                startIcon={
                  <PlusIcon color="#FFF" height={IconSize.buttonIcon} />
                }
              >
                {t('CREATE_TOP_UPS')}
              </JButton>
            </Box>
          )}
        </Stack>
      </TabsContainer>
      {items.map((item, index) => (
        <CustomTabPanel
          data-qa={`${item.title}-content`}
          value={value}
          key={item.title}
          index={index}
        >
          {item.component}
        </CustomTabPanel>
      ))}
    </>
  );
};
export default Jtab;
